export default __webpack_public_path__ + "static/media/money-back@3x.c1670b62.png";